var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { h } from "preact";
import { useState } from "preact/hooks";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "unfetch/polyfill";
import LeftArrow from "../../../icons/LeftArrow.svg";
import RightArrow from "../../../icons/RightArrow.svg";
import { buttonStyle, vpCarouselCard, vpCarouselFour, vpCarouselOne, vpCarouselThree, vpCarouselTwo } from "./Carousel.css";
import PluginItem from "../PluginItem";
var VideoCarousel = function (_a) {
    var _b, _c;
    var data = _a.data, onOpenDetailsHandler = _a.onOpenDetailsHandler, onClickPlayHandler = _a.onClickPlayHandler, setIsModalOpen = _a.setIsModalOpen, isPreview = _a.isPreview;
    var _d = useState(0), currentSlide = _d[0], setCurrentSlide = _d[1];
    var next = function () {
        setCurrentSlide(currentSlide + 1);
    };
    var prev = function () {
        setCurrentSlide(currentSlide - 1);
    };
    var carouselStyles = data.styles;
    var primaryColor = (carouselStyles === null || carouselStyles === void 0 ? void 0 : carouselStyles.primaryColor) || "#111111";
    var numberOfVideos = (_b = data.content) === null || _b === void 0 ? void 0 : _b.length;
    var maxNumOfCards = (_c = data.styles) === null || _c === void 0 ? void 0 : _c.numOfCards;
    var getMinNum = function (num) {
        return Math.min(numberOfVideos, maxNumOfCards, num);
    };
    var getShowInfinite = function (num) { return numberOfVideos > getMinNum(num); };
    var GridClasses = [vpCarouselOne, vpCarouselTwo, vpCarouselThree, vpCarouselFour];
    var getClass = function (num) { var _a; return (_a = GridClasses[getMinNum(num) - 1]) === null || _a === void 0 ? void 0 : _a[getShowInfinite(num) ? 'infinite' : 'default']; };
    var carouselSettings = {
        className: getClass(4),
        dots: false,
        slidesToShow: getMinNum(4),
        slidesToScroll: getMinNum(4),
        infinite: getShowInfinite(4),
        prevArrow: (h("button", { type: "button", onClick: prev, title: "Previous", className: buttonStyle },
            h(LeftArrow, { fill: primaryColor, width: "32px" }))),
        nextArrow: (h("button", { type: "button", onClick: next, title: "Next", className: buttonStyle },
            h(RightArrow, { fill: primaryColor, width: "32px" }))),
        arrows: true,
        vertical: false,
        lazyLoad: "ondemand",
        responsive: [
            {
                breakpoint: 1510,
                settings: {
                    className: getMinNum(4) > 3 ? getClass(3) : getClass(4),
                    slidesToShow: getMinNum(3),
                    slidesToScroll: getMinNum(3),
                    infinite: getShowInfinite(3),
                },
            },
            {
                breakpoint: 1115,
                settings: {
                    className: getMinNum(3) > 2 ? getClass(2) : getClass(3),
                    slidesToShow: getMinNum(2),
                    slidesToScroll: getMinNum(2),
                    infinite: getShowInfinite(2),
                },
            },
            {
                breakpoint: 800,
                settings: {
                    className: getMinNum(2) > 1 ? getClass(1) : getClass(2),
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: getShowInfinite(1),
                },
            },
        ],
    };
    return (h("div", { "data-testid": "carousel-plugin" },
        h(Slider, __assign({}, carouselSettings), data.content.map(function (item, idx) { return (h(PluginItem, { fixedHeight: true, className: vpCarouselCard, styles: carouselStyles, onClickPlayHandler: onClickPlayHandler, onOpenDetailsHandler: onOpenDetailsHandler, key: idx, item: item, setIsModalOpen: setIsModalOpen, isPreview: isPreview })); }))));
};
export default VideoCarousel;
